import { trpc } from 'root/src/client/v2/trpc/trpc';
import ReactPlayer from 'react-player';
import { isSafari, isIosSafari } from '@braintree/browser-detection';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
const SAFARI_SIZE_THRESHOLD_BYTES = 400 * 1024 * 1024;
export const FallbackMediaWrapper = ({ children, videoUrl, muted, autoplay, onPlay }) => {
    const getValidMediaQuery = trpc.media.getValidMedia.useQuery({ videoUrl });
    if (getValidMediaQuery.isLoading || getValidMediaQuery.isError) {
        return children;
    }
    const mediaData = getValidMediaQuery.data;
    if (mediaData === null || mediaData === void 0 ? void 0 : mediaData.isValid) {
        return children;
    }
    if (!(mediaData === null || mediaData === void 0 ? void 0 : mediaData.fallbackMedia)) {
        return children;
    }
    const { fallbackMedia } = mediaData;
    const isSafariBrowser = isSafari() || isIosSafari();
    if (isSafariBrowser && fallbackMedia.bytesSize > SAFARI_SIZE_THRESHOLD_BYTES) {
        return (<div className="flex items-center flex-col justify-center w-full h-full border-2 border-pink rounded-lg">
				<WarningAmberOutlinedIcon fontSize="large" className="!fill-pink"/>
				<p className="text-lg text-pink text-center">
					Sorry we can't display this media in the Safari Browser.<br />Media is to large!<br />Try to open in the Chrome or Firefox
				</p>
			</div>);
    }
    return (<div className="flex items-center justify-center w-full h-full">
			<ReactPlayer url={fallbackMedia.url} playing={autoplay} controls muted={muted} width="100%" height="100%" onPlay={onPlay}/>
		</div>);
};
